/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindTraceabilityRequestTypesQueryResponse,
  FindTraceabilityRequestTypesQueryParams,
} from "../types/FindTraceabilityRequestTypes.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findTraceabilityRequestTypesQueryKey = (
  params?: FindTraceabilityRequestTypesQueryParams
) =>
  [
    { url: "/v1/traceability-requests/filters/types" },
    ...(params ? [params] : []),
  ] as const

export type FindTraceabilityRequestTypesQueryKey = ReturnType<
  typeof findTraceabilityRequestTypesQueryKey
>

/**
 * @summary Find traceability request types
 * {@link /v1/traceability-requests/filters/types}
 */
export async function findTraceabilityRequestTypes(
  params?: FindTraceabilityRequestTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTraceabilityRequestTypesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/filters/types`,
    params,
    ...requestConfig,
  })
  return res
}

export function findTraceabilityRequestTypesQueryOptions(
  params?: FindTraceabilityRequestTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTraceabilityRequestTypesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindTraceabilityRequestTypesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTraceabilityRequestTypesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findTraceabilityRequestTypes(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find traceability request types
 * {@link /v1/traceability-requests/filters/types}
 */
export function useFindTraceabilityRequestTypes<
  TData = ResponseConfig<FindTraceabilityRequestTypesQueryResponse>,
  TQueryData = ResponseConfig<FindTraceabilityRequestTypesQueryResponse>,
  TQueryKey extends QueryKey = FindTraceabilityRequestTypesQueryKey,
>(
  params?: FindTraceabilityRequestTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTraceabilityRequestTypesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findTraceabilityRequestTypesQueryKey(params)

  const query = useQuery(
    {
      ...findTraceabilityRequestTypesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
